import { render, staticRenderFns } from "./AdditionalModeModal.vue?vue&type=template&id=740480a8"
import script from "./AdditionalModeModal.vue?vue&type=script&lang=js"
export * from "./AdditionalModeModal.vue?vue&type=script&lang=js"
import style0 from "./AdditionalModeModal.vue?vue&type=style&index=0&id=740480a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports